import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { loadingTrue, loadingFalse } from "../../../Reducer/loaderSlice";
import Handler from "../../../Helpers/Handler";
import Pagination from "../../../Helpers/Pagination";
import "../../../Assets/css/style.css";
import MainLayout from "../../../Partials/MainLayout";
import FeedLayout from "../../../Partials/FeedLayout";

const STATUS_COLORS = {
  PLANNING: "badge-planning",
  ONGOING: "badge-ongoing",
  COMPLETED: "badge-completed",
};

const STATUS_ICONS = {
  PLANNING: "bx-calendar-edit",
  ONGOING: "bx-play-circle",
  COMPLETED: "bx-check-circle",
};

const EventList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [events, setEvents] = useState([]);
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const limit = 9;

  const fetchEvents = async () => {
    dispatch(loadingTrue());
    const res = await Handler({
      method: "GET",
      url: `/events/event_list.php?page=${page}&limit=${limit}&q=${query}`,
    });
    dispatch(loadingFalse());
    if (res.success) {
      setEvents(res.data?.list || []);
      setTotal(res.data?.pagination?.total || 0);
    } else {
      toast.error(res.message || "Failed to load events");
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [page, query]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    setQuery(search);
  };

  const formatDate = (d) =>
    new Date(d).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });

  return (
    <MainLayout>
      <FeedLayout>
        <div className="ev-page">
          {/* Header */}
          <div className="ev-header">
            <div>
              <h1 className="ev-title">Events</h1>
              <p className="ev-subtitle">Manage and track all your events</p>
            </div>
            <button className="ev-btn-primary" onClick={() => navigate("/user/create-event")}>
              <i className="bx bx-plus" /> New Event
            </button>
          </div>

          {/* Search */}
          <form className="ev-search-bar" onSubmit={handleSearch}>
            <i className="bx bx-search ev-search-icon" />
            <input
              className="ev-search-input"
              placeholder="Search events..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <button type="submit" className="ev-btn-search">Search</button>
          </form>

          {/* Grid */}
          {events.length === 0 ? (
            <div className="ev-empty">
              <i className="bx bx-calendar-x ev-empty-icon" />
              <p>No events found</p>
              <button className="ev-btn-primary" onClick={() => navigate("/user/create-event")}>
                Create your first event
              </button>
            </div>
          ) : (
            <div className="ev-grid">
              {events.map((ev) => (
                <div
                  key={ev.id}
                  className="ev-card"
                  onClick={() => navigate(`/user/event/${ev.id}`)}
                >
                  <div className="ev-card-top">
                    <span className={`ev-badge ${STATUS_COLORS[ev.status] || "badge-planning"}`}>
                      <i className={`bx ${STATUS_ICONS[ev.status] || "bx-calendar"}`} />
                      {ev.status}
                    </span>
                    <span className="ev-date">
                      <i className="bx bx-calendar" /> {formatDate(ev.event_date)}
                    </span>
                  </div>
                  <h3 className="ev-card-title">{ev.title}</h3>
                  <p className="ev-card-desc">
                    {ev.description ? ev.description.substring(0, 90) + (ev.description.length > 90 ? "..." : "") : "No description provided."}
                  </p>
                  <div className="ev-card-footer">
                    <span className="ev-client">
                      <i className="bx bx-user" /> {ev.client_name}
                    </span>
                    <i className="bx bx-chevron-right ev-arrow" />
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* Pagination */}
          {total > limit && (
            <Pagination
              page={page}
              total={total}
              limit={limit}
              onPrev={() => setPage((p) => Math.max(1, p - 1))}
              onNext={() => setPage((p) => p + 1)}
            />
          )}
        </div>
      </FeedLayout>
    </MainLayout>

  );
};

export default EventList;